const HRMSNavigationRoutes = {
  // Employee routes
  ADD_EMP: "/employee-add",
  EDIT_JOB: (id: string) => `/edit-job/${id}`,
  EDIT_JOB_ROUTE: "/edit-job/:id",
  EMP_LIST: "/employeelist",

  // Leave routes
  ADD_LEAVE: "/leave-add",
  EDIT_LEAVE: (id: string) => `/leave/edit/${id}`,
  EDIT_LEAVE_ROUTE: "/leave/edit/:id",
  LEAVE_LIST: "/leavelist",

  // Performance routes
  ADD_PERFORMANCE: "/performance-add",
  EDIT_PERFORMANCE: (id: string) => `/performance/edit/${id}`,
  EDIT_PERFORMANCE_ROUTE: "/performance/edit/:id",
  PERFORMANCE_LIST: "/performancelist",

  // Employee Lifecycle routes
  ADD_EMP_LIFECYCLE: "/employee-lifecycle-add",
  EDIT_EMP_LIFECYCLE: (id: string) => `/employee-lifecycle/edit/${id}`,
  EDIT_EMP_LIFECYCLE_ROUTE: "/employee-lifecycle/edit/:id",
  EMP_LIFECYCLE_LIST: "/employee-lifecycle-list",

  // Other routes
  COPY_PREVIOUS: "/copy-previous",
} as const;

export default HRMSNavigationRoutes;
